import { MmuDataType, MmuModeType } from "libs/enums"
import { useEffect, useState } from "react"
import { Checkbox, Field, Toast } from "react-vant"
import { cls } from "reactutils"
import { QuestionO } from "@react-vant/icons"

type SkuCategoryAttributeDTO = SkuDetail.SkuCategoryAttributeDTO
type SkuCategoryAttributeValueDTO = SkuDetail.SkuCategoryAttributeValueDTO

type ProductDetailAttributeProps = {
  attribute: SkuCategoryAttributeDTO
  isMmu: boolean
  onChange: ({ sysNo }: { sysNo?: string }) => void
}
export default function ProductDetailAttribute({
  attribute,
  isMmu,
  onChange,
}: ProductDetailAttributeProps) {
  const [inputVal, setInputVal] = useState(null)

  useEffect(() => {
    const newInputVal = attribute.categoryAttributeValueList[0].attributeValue
    if (inputVal !== newInputVal) {
      setInputVal(newInputVal)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [attribute.categoryAttributeValueList[0].attributeValue])

  function isRadio() {
    if (isMmu) {
      return !attribute.hasCustomize && attribute.modeType === MmuModeType.RADIO
    } else {
      return true
    }
  }

  function isCheckbox() {
    return (
      !attribute.hasCustomize && attribute.modeType === MmuModeType.CHECKBOX
    )
  }

  function isTEXT() {
    return attribute.hasCustomize && attribute.dataType === MmuDataType.TEXT
  }

  function isFloat() {
    return attribute.hasCustomize && attribute.dataType === MmuDataType.FLOAT
  }
  function isInt() {
    return attribute.hasCustomize && attribute.dataType === MmuDataType.INT
  }

  function handleClickRadio(
    attribute: SkuCategoryAttributeDTO,
    attr: SkuCategoryAttributeValueDTO,
    curIndex: number,
  ) {
    if (isMmu) {
      if (attr.active) {
        if (attribute.hasRequired) return
        attr.active = false
        onChange({})
      } else {
        attribute.categoryAttributeValueList.forEach((attr, index) => {
          attr.active = index === curIndex
        })
        onChange({})
      }
    } else {
      if (attr.active) {
        if (attr.cancelAttributeSkuSysNo !== null) {
          attribute.categoryAttributeValueList.forEach((attr, index) => {
            attr.active = index === curIndex
          })
          onChange({ sysNo: attr.cancelAttributeSkuSysNo })
        }
      } else {
        attribute.categoryAttributeValueList.forEach((attr, index) => {
          attr.active = index === curIndex
        })
        onChange({ sysNo: attr.skuSysNo })
      }
    }
  }

  function handleClickCheckbox(attr: SkuCategoryAttributeValueDTO) {
    attr.active = !attr.active
    onChange({})
  }

  function handleChangeInput(val: any, attr: SkuCategoryAttributeValueDTO) {
    val = isFloat()
      ? val.replace(/^\D*(\d*(?:\.\d{0,4})?).*$/g, "$1")
      : val?.trim()
    // attr.attributeValue = val
    setInputVal(val)
  }

  function handleBlur(attr) {
    attr.attributeValue = inputVal
    attr.active = inputVal != null && inputVal != ""
    onChange({})
  }

  function inputType() {
    if (isFloat()) {
      return "number"
    } else if (isInt()) {
      return "digit"
    } else {
      return "text"
    }
  }

  return (
    <div className="item-wrap">
      <div className="item-label">{attribute.attributeName}</div>
      <div className="item-content">
        {isRadio() && (
          <div className="item-content-radio-wrap">
            {attribute.categoryAttributeValueList.map((attr, attrIndex) => (
              <div
                key={attrIndex}
                className={cls(
                  "radio-item",
                  attr.active && "active",
                  attr.disable && "disable",
                )}
                onClick={() => {
                  handleClickRadio(attribute, attr, attrIndex)
                }}
              >
                {attr.attributeValue}
              </div>
            ))}
            {attribute.attributeName === '区域属性' && <span onClick={() => Toast.info(
              {
                message: '泵类的标号仅供深圳、南京等区域项目选择，其他区域勿选；\n 选择区域属性后，系统将自动拼接强度等级与区域属性推送至云砼；\n例：强度等级选择【C30】，区域属性选择【泵】，推送时为【C30泵】'
              }
            )}><QuestionO 
            /></span>}
          </div>
        )}

        {isCheckbox() && (
          <div className="checkbox-wrap">
            {attribute.categoryAttributeValueList.map((attr, attrIndex) => (
              <Checkbox
                key={attrIndex}
                checked={attr.active}
                onChange={() => {
                  handleClickCheckbox(attr)
                }}
              >
                {attr.attributeValue}
              </Checkbox>
            ))}
          </div>
        )}
        {(isTEXT() || isFloat() || isInt()) && (
          <div className="input-wrap">
            {attribute.categoryAttributeValueList[0]?.prefix && (
              <span className="input-prefix">
                {attribute.categoryAttributeValueList[0]?.prefix}
              </span>
            )}

            <Field
              className="input"
              value={inputVal || ""}
              label=""
              type={inputType()}
              placeholder="请输入"
              onChange={(val) => {
                handleChangeInput(val, attribute.categoryAttributeValueList[0])
              }}
              onBlur={() => {
                handleBlur(attribute.categoryAttributeValueList[0])
              }}
            />
            {attribute.categoryAttributeValueList[0]?.suffix && (
              <span className="input-suffix">
                {attribute.categoryAttributeValueList[0]?.suffix}
              </span>
            )}
          </div>
        )}
      </div>
      <style jsx>{`
        .item-wrap {
          line-height: 1;
          margin-top: 30px;
          font-size: 12px;
        }
        .item-label {
          font-size: 13px;
          color: #333333;
        }
        .item-content {
          margin-top: 15px;
        }
        .item-content-radio-wrap {
          margin-top: 5px;
        }
        .radio-item {
          margin-top: 5px;
          padding: 8px 20px;
          background: #f5f5f5;
          border-radius: 14px;
          font-size: 12px;
          display: inline-block;
          vertical-align: middle;
          margin-right: 10px;
        }
        .radio-item:last-child {
          margin-right: 0;
        }
        .radio-item.active {
          background-color: var(--primaryColor);
          color: #fff;
        }
        .radio-item.disable {
          background: #f8f8f8;
          color: #bbbbbb;
        }
        .input-wrap {
          display: flex;
          align-items: center;
        }
        .input-wrap :global(.input) {
          width: 162px;
          height: 38px;
          align-items: center;
          background: #fafafa;
          border: 1px solid #d8d8d8;
          border-radius: 19px;
          padding: 0 5px;
        }
        .input-wrap :global(.input .rv-field__control) {
          text-align: center;
          font-size: 12px;
        }
        .input-prefix {
          margin-right: 10px;
        }
        .input-suffix {
          margin-left: 10px;
        }
        .checkbox-wrap {
          display: flex;
          flex-wrap: wrap;
          margin-top: -4px;
        }
        .checkbox-wrap :global(.rv-checkbox) {
          margin-right: 8px;
          margin-top: 4px;
        }
      `}</style>
    </div>
  )
}
